<template>
    <a-spin
        :spinning="resultsLoading"
    >
        <div
            class="files-result-grid"
        > 
            <template
                v-if="folderList.length > 0"
            >
            <div
                v-for="folderObj in folderList"
                :key="folderObj.uuid"
                :style="{
                    minWidth: '300px',
                    display: 'flex'
                }"
            >
                <InfoResult 
                    v-if="folderObj.isInfo"
                    :viewOnly="false"
                    :folderObj="folderObj"
                />
                <AktaResult
                    v-else
                    :viewOnly="true"
                    :folderObj="folderObj"
                />
            </div>
            </template>
            <template 
                v-else
            >
            <div 
                class="no-results"
            >
                <h1>
                    Nem található Info ezekkel a paraméterekkel
                </h1>
            </div>
            </template>
        </div>
    </a-spin>
</template>

<script>
import InfoResult from '@/components/app/info_components/InfoResult.vue';
import AktaResult from '@/components/app/akta_components/AktaResult.vue';

export default {
    components: {
        AktaResult,
        InfoResult
    },

    props: {
        folderList: {
            type: Array,
            default: () => []
        },
        resultsLoading: {
            type: Boolean,
            default: false
        }
    },

    
}
</script>

<style lang="scss" scoped>
    .files-result-grid {
        display: grid;
        grid-template-columns: 1fr;

        @include md {
            grid-template-columns: 1fr 1fr;
        }
        @include xl {
            grid-template-columns: 1fr 1fr 1fr;
        }
        
        grid-gap: 25px;

        .no-results {
            text-align: center;
            grid-column: 1 / 3
        }
    }
</style>